var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.80629 3.07551C1.89552 2.97802 2.01651 2.92325 2.14267 2.92325C2.26883 2.92325 2.38983 2.97802 2.47905 3.07551L4.99735 5.82813L7.51566 3.07551C7.55954 3.02584 7.61204 2.98622 7.67009 2.95897C7.72814 2.93171 7.79057 2.91737 7.85374 2.91677C7.91692 2.91617 7.97957 2.92933 8.03804 2.95547C8.09651 2.98162 8.14963 3.02024 8.19431 3.06907C8.23898 3.1179 8.27431 3.17596 8.29823 3.23987C8.32215 3.30378 8.33419 3.37226 8.33364 3.44132C8.33309 3.51037 8.31997 3.57861 8.29503 3.64206C8.2701 3.7055 8.23385 3.76289 8.18841 3.81086L5.33373 6.93115C5.24451 7.02865 5.12351 7.08342 4.99735 7.08342C4.87119 7.08342 4.7502 7.02865 4.66097 6.93115L1.80629 3.81086C1.7171 3.71334 1.66699 3.58109 1.66699 3.44319C1.66699 3.30529 1.7171 3.17304 1.80629 3.07551Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/drop-down-icon.c7d7ef56f13df2950ae0c7dbb1811f6e.svg";
export { ForwardRef as ReactComponent };